var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextStage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.167 17.667C14.5853 17.667 18.167 14.0853 18.167 9.66699C18.167 5.24871 14.5853 1.66699 10.167 1.66699C5.74871 1.66699 2.16699 5.24871 2.16699 9.66699C2.16699 14.0853 5.74871 17.667 10.167 17.667ZM13.8741 8.95989L10.8741 5.95989C10.4836 5.56936 9.85041 5.56936 9.45989 5.95989C9.06936 6.35041 9.06936 6.98357 9.45989 7.3741L10.7528 8.66699L7.16699 8.66699C6.61471 8.66699 6.16699 9.11471 6.16699 9.66699C6.16699 10.2193 6.61471 10.667 7.16699 10.667H10.7528L9.45989 11.9599C9.06936 12.3504 9.06936 12.9836 9.45989 13.3741C9.85041 13.7646 10.4836 13.7646 10.8741 13.3741L13.8741 10.3741C14.2646 9.98357 14.2646 9.35041 13.8741 8.95989Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextStage);
export default __webpack_public_path__ + "static/media/next-stage.d285f0ea22768a23c5ce736c7c09b136.svg";
export { ForwardRef as ReactComponent };